import "./styles.scss";

import TimezonePicker from "react-timezone";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { getCountries } from "../../../store/middleware";
import { SCButtonAddInput } from "../../../components/Buttons/styles";
import cameraIcon from "../../../assets/images/profile/ico_camera.svg";
import avatar from "../../../assets/images/profile/img_placeholder.svg";
import { setContractContactsNew } from "../../../store/slices/b2b/b2bContracts.slice";

function ContactFormList(props) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { contractContactsNew } = useSelector((state) => state.b2bContractsReducer);

  const [countries, setCountries] = useState([]);

  const loadInfos = () => {
    dispatch(getCountries()).then((res) => setCountries(res));
  };

  useEffect(() => {
    loadInfos();
    // eslint-disable-next-line
  }, []);

  const removeContactForm = (e, index) => {
    e.preventDefault();
    if (index > 0) {
      dispatch(setContractContactsNew(contractContactsNew.filter((value, i) => i !== index)));
    } else {
      dispatch(setContractContactsNew([]));
    }
  };

  const handleChange = (e, index) => {
    let { name, value } = e.target;
    if (name === "countryId") {
      value = parseInt(value);
    }

    dispatch(
      setContractContactsNew(contractContactsNew.map((item, i) => (i === index ? { ...item, [name]: value } : item))),
    );
  };

  const handleChangeInList = (e, index, idx) => {
    const { name, value, dataset } = e.target;
    const { field } = dataset;

    if (field === "userEmails") {
      if (idx === 0) {
        dispatch(
          setContractContactsNew(
            contractContactsNew.map((item, i) =>
              i === index
                ? {
                    ...item,
                    ["email"]: value,
                    ["userEmails"]: item.userEmails.map((level, levelindex) =>
                      levelindex === idx ? { ...level, [name]: value, ["notify"]: true } : level,
                    ),
                  }
                : item,
            ),
          ),
        );
      } else {
        dispatch(
          setContractContactsNew(
            contractContactsNew.map((item, i) =>
              i === index
                ? {
                    ...item,
                    ["userEmails"]: item.userEmails.map((level, levelindex) =>
                      levelindex === idx ? { ...level, [name]: value, ["notify"]: true } : level,
                    ),
                  }
                : item,
            ),
          ),
        );
      }
    }

    if (field === "userPhones") {
      dispatch(
        setContractContactsNew(
          contractContactsNew.map((item, i) =>
            i === index
              ? {
                  ...item,
                  ["userPhones"]: item.userPhones.map((phone, phoneindex) =>
                    phoneindex === idx
                      ? { ...phone, [name]: name !== "userPhoneTypeId" ? value : parseInt(value) }
                      : phone,
                  ),
                }
              : item,
          ),
        ),
      );
    }
  };

  const addEmail = async (e, item, index) => {
    e.preventDefault();

    const arrCopy = [...contractContactsNew];
    let list = arrCopy[index];

    let listCopy = { ...list };

    listCopy["userEmails"] = [...item, { email: "", notify: true }];

    arrCopy[index] = listCopy;

    dispatch(setContractContactsNew(arrCopy));
  };

  const addPhone = async (e, item, index) => {
    e.preventDefault();

    const arrCopy = [...contractContactsNew];
    let list = arrCopy[index];

    let listCopy = { ...list };

    listCopy["userPhones"] = [...item, { phone: "", userPhoneTypeId: 3 }];

    arrCopy[index] = listCopy;

    await dispatch(setContractContactsNew(arrCopy));
  };

  const removeEmail = async (e, index, findIndex) => {
    e.preventDefault();

    const arrCopy = [...contractContactsNew];
    let list = arrCopy[index];

    let listCopy = { ...list };

    listCopy["userEmails"] = listCopy["userEmails"].filter((item, idx) => idx !== findIndex);

    arrCopy[index] = listCopy;

    await dispatch(setContractContactsNew(arrCopy));
  };

  const removePhone = (e, index, findIndex) => {
    e.preventDefault();

    const arrCopy = [...contractContactsNew];
    let list = arrCopy[index];

    let listCopy = { ...list };

    listCopy["userPhones"] = listCopy["userPhones"].filter((item, idx) => idx !== findIndex);

    arrCopy[index] = listCopy;

    dispatch(setContractContactsNew(arrCopy));
  };

  const handleUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const { index } = e.target.dataset;
      const fileSize = file.size / 1024 / 1024;
      if (fileSize <= 2) {
        let reader = new FileReader();
        reader.onload = (evt) => {
          handleChange({
            target: {
              name: "picture",
              value: evt.target.result,
              dataset: {
                index,
              },
            },
          });
        };

        reader.readAsDataURL(file);
        const event = {
          target: {
            name: "file",
            value: file,
            dataset: {
              index,
            },
          },
        };
        handleChange(event);
      }
    }
  };

  return (
    <div>
      {contractContactsNew?.map((item, index) => {
        return (
          <div key={index * 99}>
            <div>
              {t("NEW")} {t("CONTACT")} #{index + 1}
              <SCButtonAddInput
                type="button"
                name="remove"
                onClick={(e) => {
                  removeContactForm(e, index);
                }}
              >
                {t("DELETE")} <i className="fa fa-times-circle-o" aria-hidden="true" />
              </SCButtonAddInput>
            </div>
            <div className="viewUser">
              <div className="changePhoto">
                <h2>{t("PHOTO")}</h2>
                <div style={{ margin: "0" }}>
                  <div className="photo">
                    <img
                      src={item.picture ? item.picture : avatar}
                      alt="Avatar"
                      width="112"
                      height="112"
                      className="avatarRound"
                    />
                    <div className="fileUpload btn btn-primary">
                      <span>
                        <img src={cameraIcon} alt="Camera" width="16" height="14" />
                        {t("CHANGE")}
                      </span>
                      <input
                        id="uploadBtn"
                        type="file"
                        className="upload"
                        data-index={index}
                        onChange={handleUpload}
                        accept="image/x-png,image/jpeg"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="formulario">
                <div>
                  <div>
                    <label>{t("NAME")}</label>
                    <span>{t("REQUIRED")}</span>
                  </div>
                  <input
                    placeholder="Your name"
                    name="name"
                    data-index={index}
                    type="text"
                    className="inputMobile"
                    value={item.name}
                    onChange={(e) => handleChange(e, index)}
                  />
                </div>

                {item?.userEmails?.map((i, idx) => {
                  return (
                    <div key={"e" + idx}>
                      <div>
                        <label>{idx === 0 ? "Login email" : t("ALTERNATIVE_EMAIL")}</label>
                        <span>{t("REQUIRED")}</span>
                      </div>
                      <input
                        data-index={index}
                        data-subindex={idx}
                        placeholder="Your email"
                        name="email"
                        data-field="userEmails"
                        type="email"
                        className="inputMobile"
                        value={i.email}
                        onChange={(e) => handleChangeInList(e, index, idx)}
                      />

                      {idx > 0 ? (
                        <SCButtonAddInput
                          data-index={index}
                          data-subindex={idx}
                          data-field="userEmails"
                          name="remove"
                          onClick={(e) => removeEmail(e, index, idx)}
                        >
                          {t("DELETE")} <i className="fa fa-times-circle-o fa-lg"></i>
                        </SCButtonAddInput>
                      ) : (
                        <SCButtonAddInput
                          type="button"
                          data-field="userEmails"
                          data-index={index}
                          onClick={(e) => addEmail(e, item?.userEmails, index)}
                        >
                          {t("ADD_EMAIL")} +
                        </SCButtonAddInput>
                      )}
                    </div>
                  );
                })}
                <div className="inputs">
                  <div className="lineInputs">
                    <div>
                      <label>{t("GENDER")}</label>
                      <span>{t("REQUIRED")}</span>
                    </div>
                    <select
                      value={item.gender}
                      data-index={index}
                      onChange={(e) => handleChange(e, index)}
                      className="input-lingo"
                      name="gender"
                    >
                      <option value="male">{t("MALE")}</option>
                      <option value="female">{t("FEMALE")}</option>
                    </select>
                  </div>

                  <div className="lineInputs">
                    <div>
                      <label>{t("COUNTRY")}</label>
                      <span>{t("REQUIRED")}</span>
                    </div>
                    <select
                      value={item.countryId}
                      data-index={index}
                      onChange={(e) => handleChange(e, index)}
                      className="input-lingo"
                      name="countryId"
                    >
                      <option>Select</option>
                      {countries.map((item) => {
                        return (
                          <option key={item.id} value={item.id}>
                            {item.name}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>

                <div className="inputs">
                  <div className="lineInputs timezoneCard">
                    <div>
                      <label>Timezone</label>
                      <span>{t("REQUIRED")}</span>
                    </div>
                    <TimezonePicker
                      value={item.timezone}
                      onChange={(timezoneName) => {
                        const e = {};
                        e.target = {
                          name: "timezone",
                          value: timezoneName,
                          dataset: {
                            index,
                          },
                        };
                        handleChange(e, index);
                      }}
                      inputProps={{
                        placeholder: "Select Timezone...",
                        name: "timezone",
                      }}
                    />
                  </div>
                  <div className="lineInputs">
                    <p style={{ margin: "22px 0 0 0" }}>
                      Current time <br />
                      in this timezone: {props.util.getFormattedTimezone(item.timezone)}
                    </p>
                  </div>
                </div>

                <div>
                  <div>
                    <label>{t("ADDRESS")}</label>
                    <span>{t("REQUIRED")}</span>
                  </div>
                  <input
                    placeholder="Address"
                    data-index={index}
                    name="address"
                    value={item.address}
                    onChange={(e) => handleChange(e, index)}
                  />
                </div>

                {item?.userPhones?.map((i, idx) => {
                  return (
                    <div key={"phone" + idx} className="inputs">
                      <div className="lineInputs">
                        <div>
                          <label>{t("TELEPHONE")}</label>
                          <span>{t("REQUIRED")}</span>
                        </div>
                        <div>
                          <input
                            placeholder="Phone number"
                            name="phone"
                            data-index={index}
                            data-subindex={idx}
                            data-field="userPhones"
                            type="text"
                            value={i.phone}
                            onChange={(e) => handleChangeInList(e, index, idx)}
                          />
                        </div>
                      </div>
                      <div className="lineInputs">
                        <div>
                          <label>{t("TYPE")}</label>
                          <span>{t("REQUIRED")}</span>
                        </div>
                        <select
                          value={i.userPhoneTypeId}
                          onChange={(e) => handleChangeInList(e, index, idx)}
                          className="input-lingo"
                          name="userPhoneTypeId"
                          data-field="userPhones"
                          data-subindex={idx}
                          data-index={index}
                        >
                          <option value="1">Commercial</option>
                          <option value="2">Residential</option>
                          <option value="3">Mobile</option>
                          <option value="4">Whatsapp</option>
                        </select>
                      </div>
                      <div className="lineInputs">
                        {idx === 0 && (
                          <SCButtonAddInput
                            type="button"
                            data-index={index}
                            data-field="userPhones"
                            onClick={(e) => addPhone(e, item.userPhones, index)}
                          >
                            Add {t("TELEPHONE")} +
                          </SCButtonAddInput>
                        )}
                        {idx > 0 && (
                          <SCButtonAddInput
                            data-index={index}
                            data-field="userPhones"
                            name="remove"
                            onClick={(e) => removePhone(e, index, idx)}
                          >
                            {t("DELETE")} <i className="fa fa-times-circle-o fa-lg"></i>
                          </SCButtonAddInput>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default ContactFormList;
